import {
  Edit,
  SimpleForm,
  TextInput,
  ArrayInput,
  SimpleFormIterator,
  BooleanInput,
  required,
  DeleteButton,
  useRecordContext,
} from "react-admin";

const OAuthClientEditTitle = () => {
  const record = useRecordContext();
  return record
    ? `Редактировать: ${record.name ?? record.clientId}`
    : "Редактировать OAuth клиент";
};

export const OAuthClientEdit = () => (
  <Edit
    title={<OAuthClientEditTitle />}
    actions={<DeleteButton mutationMode="pessimistic" />}
  >
    <SimpleForm>
      <TextInput source="clientId" label="Client ID" disabled />
      <TextInput
        source="name"
        label="Client Name"
        validate={required()}
        fullWidth
      />

      <ArrayInput
        source="redirectUris"
        label="Redirect URIs"
        validate={required()}
      >
        <SimpleFormIterator inline>
          <TextInput source="" label="URI" helperText={false} fullWidth />
        </SimpleFormIterator>
      </ArrayInput>

      <ArrayInput source="allowedScopes" label="Allowed Scopes">
        <SimpleFormIterator inline>
          <TextInput source="" label="Scope" helperText={false} />
        </SimpleFormIterator>
      </ArrayInput>

      <BooleanInput source="isActive" label="Active" />
    </SimpleForm>
  </Edit>
);
